import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import useSearchAndFilter from "../../../hooks/useSearchAndFilter";
import { Table } from "../../../components/shared";
import { Loader } from "../../../components/loaders/loaders";
import {
  ServiceTypeResponseType,
  ServiceTypeTableConfig,
} from "./Services-types";
import { AddIcon, FilterIcon, FilterIconWhite } from "../../../assets";
import ServicesModal from "../../../components/modals/systemConfigurationModal/AddServiceModal";
import { GET_SERVICES } from "../../../apis/end-points";
import FilterSideMenu from "../../../components/shared/FilterSideMenu";
import { Badge } from "@mui/material";
import { DEFAULT_PAGE_SIZE } from "../../../utils/constants";
import { capitalizeEachWord } from "../../../utils/utils";

/**
 * Maps user data from the API response to the format required by the table.
 *
 * @param {Users[]} userData - Array of user objects.
 * @returns {object[]} - Mapped user data.
 */
const mapUserData = (data: ServiceTypeResponseType[]): object[] =>
  data.map((item) => ({
    id: item?.id || "",
    count: item?.count || "",
    serviceName: item?.name || "",
    onwardServiceName: item?.onwardServiceName || "",
    description: item?.description || "",
    shortName: item?.shortName || "",
    agentType: item?.agentType?.name || "",
    agentTypeId: item?.agentType?.id || "",
    deliverWithin: item?.deliverWithin || "",
    comment: item?.comment || "",
    dispatchColor: item?.dispatchTicketColor || "#bb0707",
    dispatchPrinter: item?.dispatchPrinter || "",
    useOver150Lbs: item?.useOver150Lbs || false, // Boolean values should default to `false`
    canCustomerUse: item?.canCustomerUse || false, // Boolean values should default to `false`
    active: item?.isActive || false,
    longName: item?.longName || "",
    vehicleType: item?.vehicleType || "",
    // Capitalised for the table cell; the edit modal matches it case-insensitively.
    logisticsType: capitalizeEachWord(item?.logisticsType || ""),
    serviceDays: item?.serviceDays || [],
    minsNotReceiveMsg: item?.minsNotReceiveMsg || "",
    minsNotReadMsg: item?.minsNotReadMsg || "",
    zoneSet: item?.zoneSet || "",
    delSignRequired: item?.delSignRequired || false,
    printDispatchTrack: item?.printDispatchTrack || false,
    orderDispatch: item?.orderDispatch || false,
    notReceivedMsgAlert: item?.notReceivedMsgAlert || false,
    notReadMsgAlert: item?.notReadMsgAlert || false,
    skipPickupStops: item?.skipPickupStops || false,
    skipDelRoundStops: item?.skipDelRoundStops || false,
    discInvoiceLevel: item?.disInvoiceLevel || false,
    availCust: item?.availCust || false,
  }));

// );

const Services: React.FC = () => {
  const navigate = useNavigate();
  const [openAddServiceModal, setOpenAddServiceModal] =
    useState<boolean>(false);
  const [rowData, setRowData] = useState<any>();

  const {
    data,
    loading,
    setLoading,
    fetchFilteredData,
    fetchWithCurrentFilters,
    closeOpenfilterModal,
    isShowFilterModal,
    selectStatus,
    setSelectStatus,
    refreshPage,
    service,
    setService,
    logisticsTypeSelected,
    setLogisticsTypeSelected,
    filterApplied,
    setFilterApplied,
    captureAppliedFilters,
    clearCurrentFilters,
  } = useSearchAndFilter<ServiceTypeResponseType>({
    apiUrl: GET_SERVICES,
    limit: DEFAULT_PAGE_SIZE,
    mapUserData,
    screenKey: "services",
  });

  const handleEditModal = (data: any) => {
    setOpenAddServiceModal(true);
    setRowData(data);
  };
  return (
    <>
      <div
        className={`tableWrap ${
          isShowFilterModal ? "tableWrap--filterOpen" : ""
        }`}>
        <div className="tableWrap__head tableWrap__head--end">
          <div className="btn__group">
          {filterApplied ? (
                <Badge badgeContent=" " color="primary">
                  <button
                    className={
                      !isShowFilterModal ? "btn btn__white" : "btn btn__primary"
                    }
                    onClick={closeOpenfilterModal}
                  >
                    {!isShowFilterModal ? <FilterIcon /> : <FilterIconWhite />}
                    Filter
                  </button>
                </Badge>
              ) : (
                <button
                  className={
                    !isShowFilterModal ? "btn btn__white" : "btn btn__primary"
                  }
                  onClick={() => {
                    // setShowEditColumn(false);
                    closeOpenfilterModal();
                  }}
                >
                  {!isShowFilterModal ? <FilterIcon /> : <FilterIconWhite />}
                  Filter
                </button>
            )}
            <FilterSideMenu
              isShowFilterModal={isShowFilterModal}
              closeOpenfilterModal={closeOpenfilterModal}
              selectStatus={selectStatus}
              setSelectStatus={setSelectStatus}
              isStatusHide={false}
              isRoleHide={true}
              isOrderStatusHide={true}
              isOrderTypeHide={true}
              isAgentTypeHide={true}
              isHubHide={true}
              isServiceHide={true}
              isCustomerTypeHide={false}
              isAllCustomerTypeHide={true}
              showService = {true}
              service = {service}
              setService = {setService}
              showLogisticsType={true}
              logisticsTypeSelected={logisticsTypeSelected}
              setLogisticsTypeSelected={setLogisticsTypeSelected}
              fetchFilteredData={fetchFilteredData}
              onFiltersApplied={captureAppliedFilters}
              filterApplied = {filterApplied}
              setFilterApplied = {setFilterApplied}
              table= "service"
              clearFiltersFromStorage={clearCurrentFilters}
            />
          <button
            className="btn btn__white w_fitContent"
            onClick={() => {
              setOpenAddServiceModal(true);
            }}
          >
            <AddIcon />
            Create New
          </button>
        </div>
        </div>
        <Table
          columns={ServiceTypeTableConfig.columns}
          data={data}
          setLoading={setLoading}
          editModalHanlde={handleEditModal}
          onDeleteConfig={ServiceTypeTableConfig.delete}
          onActiveConfig={ServiceTypeTableConfig.active}
          getApiData={fetchWithCurrentFilters}
          deleteIcon={true}
          activeIcon={true}
          editIcon={true}
        />
      </div>
      {openAddServiceModal && (
        <ServicesModal
          handleClose={() => {
            setOpenAddServiceModal(false);
            setRowData(null);
          }}
          setLoading={setLoading}
          refreshList={() => refreshPage()}
          data={rowData}
        />
      )}
      {loading && <Loader />}
    </>
  );
};

export default Services;
